/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useState } from "react";

import { useTranslation } from "react-i18next";

import { ICON_DEFAULT_STYLE } from "@/shared";

import { AddIcon } from "@dotnet/telematics-design-system";

import Button from "../../../../../components/Button/Button";
import CreateNewsDialog from "../Dialogs/CreateNewsDialog/CreateNewsDialog";

const CreateNewsButton = () => {
  const { t } = useTranslation();

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const handleAddNewsButtonClick = () => {
    setIsDialogOpen(true);
  };

  const handleCloseCreateNewsDialog = (resetAllVal: () => void) => {
    setIsDialogOpen(false);
    resetAllVal();
  };

  return (
    <>
      <Button
        data-testid="create-news-button"
        size="tiny"
        variant="iconLeft"
        icon={<AddIcon style={ICON_DEFAULT_STYLE} />}
        color="secondary"
        onClick={handleAddNewsButtonClick}
        css={css({ backgroundColor: "transparent" })}
      >
        {t("News##create news")}
      </Button>

      <CreateNewsDialog
        isDialogOpen={isDialogOpen}
        onClose={handleCloseCreateNewsDialog}
      />
    </>
  );
};

export default CreateNewsButton;
